

import moment from "moment-timezone";

export const formatTime = (currentTime, offset = null, format) => {
    const adjustedTime = moment(currentTime).utcOffset(offset);

    if (format) {
        return {
            hour: adjustedTime.format('HH:mm:ss').split(':')[0],
            minute: adjustedTime.format('HH:mm:ss').split(':')[1],
            secund: adjustedTime.format('HH:mm:ss').split(':')[3]
        }
    } else {
        return {
            hour: adjustedTime.format('h:mm:ss A').split(':')[0],
            minute: adjustedTime.format('h:mm:ss A').split(':')[1],
            secund: adjustedTime.format('h:mm:ss A').split(':')[2].split(" ")[0],
            period: adjustedTime.format('h:mm:ss A').split(':')[2].split(" ")[1]
        }
    }

};


